/**
 * Thin wrapper over sonner's toast functions with typed variants.
 * Feature code imports from this file, not from sonner directly,
 * so we can swap toast library later without touching consumers.
 */
import { toast as sonnerToast } from "sonner";

export const toast = {
  success: (message: string, description?: string) =>
    sonnerToast.success(message, description ? { description } : undefined),
  error: (message: string, description?: string) =>
    sonnerToast.error(message, description ? { description } : undefined),
  info: (message: string, description?: string) =>
    sonnerToast.info(message, description ? { description } : undefined),
  warning: (message: string, description?: string) =>
    sonnerToast.warning(message, description ? { description } : undefined),
  /** Promise-based: shows loading → success/error from the promise. */
  promise: sonnerToast.promise.bind(sonnerToast),
};
